import { ACCEPT_PAYMENTS } from '@/common/permissionConstants';
import { useDevOnly } from '@/composables/useDevOnly';

const devOnlyGuard = () => {
    const { isDev } = useDevOnly();
    if (!isDev()) return { name: 'home' };
};

export default [
    {
        path: 'ledger',
        name: 'ledger',
        meta: {
            label: 'Patient ledger',
            hasPermission: ACCEPT_PAYMENTS,
        },
        component: () => import('@/views/LedgerOrchestrationPage.vue'),
        beforeEnter: devOnlyGuard,
    },
];
